import colors from "/styles/colors";
export const componentStyles = new String(".simpo-component-wrapper.jsx-3ccce5a4b4c749fd{.action-bar-wrapper.jsx-3ccce5a4b4c749fd{min-height:150px}}");
componentStyles.__hash = "3ccce5a4b4c749fd";
